import type { Translations } from "../types";

const hi: Translations = {
  "meta.title": "देश अनुसार क्लिक मानचित्र",
  "meta.description":
    "इंटरैक्टिव विश्व मानचित्र: प्रत्येक देश के लिए मुफ़्त क्लिक, साथ ही Stripe, PayPal और Buy Me a Coffee के ज़रिए सशुल्क सहयोग।",

  "app.title": "देश अनुसार क्लिक मानचित्र",

  "map.intro":
    "मानचित्र पर किसी देश पर क्लिक करके उसे मुफ़्त वोट दें, या उसे आर्थिक सहयोग भेजें - दोनों ही नीचे दी गई संयुक्त लीडरबोर्ड में जुड़ते हैं। यह मानचित्र केवल इस ऐप के भीतर मिले सहयोग को दर्शाता है, किसी देश की वास्तविक संपत्ति या GDP को नहीं।",
  "map.verifying": "सत्यापन हो रहा है …",
  "map.confirmNotRobot": "मुफ़्त क्लिक जोड़ने से पहले, कृपया जल्दी से पुष्टि करें कि आप रोबोट नहीं हैं:",
  "map.tryAgain": "फिर से कोशिश करें",
  "map.registeringClick": "क्लिक दर्ज की जा रही है …",
  "map.selectedCountry": "चयनित देश: {name}.",
  "map.selectFirstFeedback": "देश चुन लिया गया है। मुफ़्त क्लिक जोड़ने के लिए, पहले नीचे पुष्टि करें कि आप रोबोट नहीं हैं।",
  "map.verificationExpired": "सत्यापन की अवधि समाप्त हो गई - कृपया फिर से पुष्टि करें कि आप रोबोट नहीं हैं।",
  "map.slowDown": "थोड़ा धीरे - अगली क्लिक से पहले थोड़ा इंतज़ार करें।",
  "map.clickFailed": "क्लिक दर्ज नहीं हो सकी। कृपया फिर से कोशिश करें।",
  "map.clickErrorGeneric": "क्लिक दर्ज करने में त्रुटि हुई।",
  "map.leaderboardHeading": "देश लीडरबोर्ड",
  "map.emptySelection": "क्लिक करने या सहयोग देने के लिए मानचित्र पर एक देश चुनें।",
  "map.loadingData": "डेटा लोड हो रहा है …",

  "worldmap.loadError": "मानचित्र लोड नहीं हो सका।",
  "worldmap.resetZoom": "ज़ूम रीसेट करें",
  "worldmap.resetButton": "⤾ रीसेट",
  "worldmap.loadingMap": "मानचित्र लोड हो रहा है …",
  "worldmap.unknownCountry": "अज्ञात",
  "worldmap.ariaClicks": "{name}: {clicks} क्लिक",
  "worldmap.tooltipClicks": "{clicks} क्लिक",

  "legend.fewer": "कम क्लिक",
  "legend.more": "ज़्यादा क्लिक",

  "list.empty": "अभी तक कोई क्लिक नहीं। सबसे पहले बनें!",
  "list.ariaLabel": "क्लिक के अनुसार देश लीडरबोर्ड",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY सेट नहीं है - कॉन्फ़िगरेशन के लिए README देखें।",
  "human.verificationFailedGeneric": "सत्यापन विफल रहा।",
  "human.networkError":
    "सत्यापन सेवा तक नहीं पहुँच सके (नेटवर्क त्रुटि) - कृपया VITE_SUPABASE_URL, verify-human डिप्लॉय हुआ है या नहीं, और ALLOWED_ORIGIN जाँचें; अधिक जानकारी के लिए README/NAVODILA देखें।",
  "human.verificationFailedRetry": "सत्यापन विफल रहा, फिर से कोशिश करें।",

  "provider.stripe": "💳 कार्ड (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "चयनित देश",
  "panel.currentlyRanked": "वर्तमान रैंक #{rank}",
  "panel.shareCopied": "कॉपी हो गया ✓",
  "panel.shareShared": "साझा किया गया ✓",
  "panel.shareButton": "🔗 साझा करें",

  "panel.tableClicks": "क्लिक",
  "panel.tableFree": "मुफ़्त",
  "panel.tablePaid": "सशुल्क",
  "panel.rowAllTime": "अब तक",
  "panel.rowThisYear": "इस साल",
  "panel.rowThisWeek": "इस सप्ताह",
  "panel.rowToday": "आज",

  "panel.totalCombined": "कुल योग:",
  "panel.totalSupport": "कुल सहयोग:",

  "panel.paymentMethod": "भुगतान का तरीका",
  "panel.noPaymentMethod": "फ़िलहाल कोई भुगतान तरीका उपलब्ध नहीं है।",
  "panel.supportAmount": "सहयोग राशि (EUR)",
  "panel.amountRange": "राशि {min} और {max} के बीच होनी चाहिए।",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "अनुमानित सशुल्क क्लिक:",
  "panel.ratioInfo":
    "अनुपात: {a} = {b} क्लिक (उदाहरण के लिए {c} = {d} क्लिक)। यह भुगतान से पहले का केवल एक अनुमान है - अंतिम क्लिक संख्या हमेशा सर्वर द्वारा वास्तव में पुष्ट हुए भुगतान के आधार पर तय और पुष्ट की जाती है।",
  "panel.preparing": "तैयारी हो रही है …",
  "panel.continueWith": "{provider} के साथ जारी रखें",
  "panel.choosePaymentMethod": "भुगतान का तरीका चुनें",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME सेट नहीं है - कॉन्फ़िगरेशन के लिए README देखें।",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID सेट नहीं है - कॉन्फ़िगरेशन के लिए README देखें।",

  "panel.paypalAmountInfo": "राशि: {amount} (अनुमानित {clicks} क्लिक)। नीचे दिए गए PayPal बटन से भुगतान पूरा करें।",
  "panel.back": "← वापस",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee पर जाने से पहले:",
  "panel.bmcWarningBody":
    "चेकआउट के समय नीचे दिया गया कोड मैसेज/नोट फ़ील्ड में पेस्ट करें — यही एकमात्र तरीका है जिससे हमें पता चलेगा कि आप किस देश को सहयोग दे रहे हैं। बिना कोड के, हम भुगतान को किसी भी देश से नहीं जोड़ सकते।",
  "panel.copy": "कॉपी करें",
  "panel.copied": "कॉपी हो गया ✓",
  "panel.suggestedAmount": "सुझाई गई राशि:",
  "panel.bmcAmountNote":
    "(अनुमानित {clicks} क्लिक)। दुर्भाग्य से BuyMeCoffee लिंक के ज़रिए राशि आगे भेजने का समर्थन नहीं करता — कृपया उनकी साइट पर खुद राशि दर्ज या चुनें। वास्तविक क्लिक संख्या हमेशा उस राशि से तय होती है जो आप वाकई BuyMeCoffee पर भेजते हैं, इस अनुमान से नहीं।",
  "panel.openBmc": "BuyMeCoffee खोलें और जारी रखें →",
  "panel.waitingProvider": "भुगतान प्रदाता से भुगतान की पुष्टि का इंतज़ार हो रहा है …",
  "panel.waitingConfirmation": "भुगतान की पुष्टि का इंतज़ार हो रहा है …",
  "panel.timedOut":
    "जाँच में समय समाप्त हो गया। अगर आपने भुगतान पूरा कर लिया है, तो सर्वर को पुष्टि मिलते ही मानचित्र अपडेट हो जाएगा - इसमें कभी-कभी थोड़ा अधिक समय लग सकता है।",
  "panel.checkAgain": "फिर से जाँचें",

  "panel.cancelled": "भुगतान रद्द हो गया या पूरा नहीं हो सका। मानचित्र में कोई बदलाव नहीं हुआ है।",
  "panel.tryAgain": "फिर से कोशिश करें",

  "panel.confirmed": "✅ सहयोग की पुष्टि हो गई!",
  "panel.confirmedBody": "{country} को {amount} के लिए {clicks} सशुल्क क्लिक मिलीं।",

  "panel.errorPreparingSupport": "आपका सहयोग तैयार करने में त्रुटि हुई।",
  "panel.errorPreparingPayment": "भुगतान तैयार करने में त्रुटि हुई।",
  "panel.errorConfirmingPayment": "भुगतान की पुष्टि करने में त्रुटि हुई।",
  "panel.errorPayingPaypal": "PayPal से भुगतान करने में त्रुटि हुई।",

  "share.unranked": "{flag}{country} को विश्व मानचित्र पर आपके सहयोग की ज़रूरत है!\nइसे लीडरबोर्ड में ऊपर चढ़ने में मदद करें 👇",
  "share.rank1": "{flag}{country} फ़िलहाल #1 पर है!\nहमें शीर्ष पर बनाए रखने में मदद करें 👇",
  "share.rankN": "{flag}{country} फ़िलहाल #{rank} पर है!\nहमें #1 तक पहुँचाने में मदद करें 👇",

  "language.switcherLabel": "भाषा",
};

export default hi;
